import { Head } from "@inertiajs/react";
import { useModalStack } from "@inertiaui/modal-react";
import { t } from "@travily/i18n";
import { sessionMagicLinkPath } from "@travily/routes";
import { Alert } from "@ui/components/Alert";
import { BOTTOM_BAR_FLOATING_OFFSET } from "@ui/components/BottomBar";
import { useCsrfToken } from "@/hooks/use-csrf-token";
import { FEATURE_FLAGS, useFeatureFlag } from "@/hooks/use-feature-flag";
import { useFlashAlerts } from "@/hooks/use-flash-alerts";
import { AuthFrame, aboutNavLink } from "@/layouts/auth-frame";
import { AppBottomBar } from "@/layouts/components/app-bottom-bar";
import { AUTH_PROVIDERS } from "@/lib/routes";
import { LoginView } from "./show.view";

const LoginPage = () => {
  const csrf = useCsrfToken();
  const isFacebookEnabled = useFeatureFlag(FEATURE_FLAGS.FACEBOOK_LOGIN);
  const { alerts } = useFlashAlerts();
  const { visitModal } = useModalStack();

  const socialProviders = [
    { id: "google" as const, action: AUTH_PROVIDERS.google },
    ...(isFacebookEnabled ? [{ id: "facebook" as const, action: AUTH_PROVIDERS.facebook }] : []),
  ];

  return (
    <>
      <Head title={t("web.logins.show.meta_title")}>
        <meta name="description" content={t("web.logins.show.meta_description")} />
      </Head>
      <AuthFrame navLinks={[aboutNavLink()]}>
        <LoginView
          alert={alerts.map((a) => <Alert key={a.id} status={a.status} title={a.title} description={a.description} />)}
          csrfToken={csrf}
          socialProviders={socialProviders}
          onEmailClick={() => visitModal(sessionMagicLinkPath())}
        />
      </AuthFrame>
      {/* The floating bar overlays the page and this page has no `Frame` to reserve clearance for
          it, so carry the spacer here. `md:hidden` mirrors the bar's own breakpoint. */}
      <div aria-hidden className="md:hidden" style={{ height: BOTTOM_BAR_FLOATING_OFFSET }} />
      <AppBottomBar />
    </>
  );
};

export default LoginPage;
